import type { RatesResponse } from '@/types/analytics'

import { api } from './client'

export interface GetRatesParams {
  date?: string;
  currency?: string;
}

export const analyticsApi = {
  getRates: (params?: GetRatesParams) =>
    api.get<RatesResponse>('/rates', params),
}
